var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"424cdffdc20f8df75767cc29acc5058414d53c7a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-order@docupet"]={id:"424cdffdc20f8df75767cc29acc5058414d53c7a"};
      